import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiscoverNav = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4053_32)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "inherit",
			fillRule: "evenodd",
			d: "M5 16C5 9.925 9.925 5 16 5s11 4.925 11 11-4.925 11-11 11S5 22.075 5 16ZM16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3Zm5.92 8.394a1 1 0 0 0-1.314-1.313l-6.02 2.58a3.667 3.667 0 0 0-1.925 1.925l-2.58 6.02a1 1 0 0 0 1.313 1.313l6.02-2.58a3.667 3.667 0 0 0 1.925-1.925l2.58-6.02Zm-6.546 3.105 3.722-1.595-1.595 3.722a1.667 1.667 0 0 1-.875.875l-3.722 1.595 1.595-3.722c.169-.393.482-.706.875-.875Z",
			clipRule: "evenodd"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4053_32",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "white",
			d: "M0 0h32v32H0z"
		})
	}) })]
});
export default SvgDiscoverNav;
